import MaintenanceIcon from "../../images/maintenance.svg";
import RecommendationIcon from "../../images/recommendation.svg";
import HazardIcon from "../../images/hazard.svg";
import LimitIcon from "../../images/limit.svg";
import InfoIcon from "../../images/info.svg";

export const formattedDate = (date) => {
  if (!date) return "";

  const dateObj = new Date(date);
  const formattedDate = dateObj.toLocaleDateString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const formattedTime = dateObj.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return `${formattedDate} ${formattedTime}`;
};

export const ConcerningLevelLibrary = {
  issues: {
    0: {
      name: "Maintenance",
      colorRule: "concerning-level-maintenance",
      colorLabel: "concern-maintenance",
      icon: MaintenanceIcon,
    },
    1: {
      name: "Recommendation",
      colorRule: "concerning-level-recommendation",
      colorLabel: "concern-recommendation",
      icon: RecommendationIcon,
    },
    2: {
      name: "Safety Hazard",
      colorRule: "concerning-level-safety-hazard",
      colorLabel: "concern-hazard",
      icon: HazardIcon,
    },
  },
  limits: {
    0: {
      name: "Limit",
      colorRule: "concerning-level-limit",
      colorLabel: "concern-limit",
      icon: LimitIcon,
    },
  },
  infos: {
    0: {
      name: "Info",
      colorRule: "concerning-level-info",
      colorLabel: "concern-info",
      icon: InfoIcon,
    },
  },
};

export const calculateSticky = (
  isMobile = true,
  activeSectionEl,
  titleSelector,
  subtitleSelector = null
) => {
  const activeSectionRect = activeSectionEl.getBoundingClientRect();
  const childTitleEl = activeSectionEl.querySelector(titleSelector);
  const childTitleRect = childTitleEl?.getBoundingClientRect();

  const offset = isMobile ? 60 : 0;
  const topHeight = -34 + offset;
  const bottomHeight = 10 + offset;

  if (!subtitleSelector) {
    if (!childTitleRect) return false;
    return (
      activeSectionRect.top <= (0 + offset - childTitleRect.height) / 2 &&
      activeSectionRect.bottom >= bottomHeight
    );
  }

  const parentElement = activeSectionEl.closest(".individual-issue-wrapper");
  if (!parentElement) return false;
  const childSubtitleEl = parentElement.querySelector(subtitleSelector);
  const childSubtitleRect = childSubtitleEl?.getBoundingClientRect();

  return (
    childSubtitleRect?.top <= topHeight &&
    activeSectionRect?.bottom >= bottomHeight
  );
};
